import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteAvsInternalAccountSchema = z.object({
  id: z.number(),
});

export const getAvsInternalAccountsRequestSchema = z.object({
  sort: zodSortField(["label"]),
});

export const addAvsInternalAccountSchema = z.object({
  sellingType: z
    .string()
    .min(1, "Le type de vente est requis")
    .max(20, "Maximum de caractères atteint"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(50, "Maximum de caractères atteint"),
  accountNumber: z.string().min(8, "Le n° de compte est incohérent"),
  siret: z.string().regex(/^\d{14}$/, "Le kvps est incohérent"),
});

export const editAvsInternalAccountSchema = z.object({
  id: z.number().optional(),
  sellingType: z
    .string()
    .min(1, "Le type de vente est requis")
    .max(20, "Maximum de caractères atteint"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(50, "Maximum de caractères atteint"),
  accountNumber: z.string().min(8, "Le n° de compte est incohérent"),
  siret: z.string().regex(/^\d{14}$/, "Le kvps est incohérent"),
  isActive: z.boolean().default(true),
});
